
import { Box, Typography } from '@mui/material'
import { blue } from '../../../../colors'
import { styled } from '@mui/material/styles'
import type { Theme } from '@mui/system'

interface TextListWrapperProp {
  theme?: Theme
  expanded?: boolean
}

export const TextListWrapper = styled(Typography)<TextListWrapperProp>(({ theme, expanded }) => ({
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  display: expanded ? 'block' : 'flex',
  alignItems: expanded ? 'unset' : 'center',
  gap: theme.spacing(1),
  textTransform: 'capitalize',
  fontSize: '14px'
}))

interface StyledButtonBoxProps {
  theme?: Theme
}

export const ToolTipWrapper = styled(Box)<StyledButtonBoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  color: blue[500],
  cursor: 'pointer',
  textDecoration: 'underline',
  textUnderlineOffset: theme.spacing(0.5)
}))
